var NeatolabsTakeyaCart = {
    // ---------------------------------------------------
    // Handle Add to Cart
    // ---------------------------------------------------
    updateTheme : (product) => {
        //console.log("update Theme----", product)
        theme.productCards = theme?.productCards || {};
        theme.productCards[product.product_id] = [{
            "available": true,
            "badgeText": "",
            "color": "default",
            "compareAtPrice": 0,
            "id": product?.variant_id,
            "imageSrc": "",
            "inventory": 1,
            "price": 1,
            "size" :1,
            "url": `/products/${product?.handle}?variant=${product?.variant_id}`
        }];
        theme.variants = theme?.variants || {}
        theme.variants[product?.variant_id] = {
            "available" : true,
            "badgeText" : "",
            "color":"default",
            "compareAtPrice" : 0,
            "id" : product?.variant_id,
            "imageSrc":"",
            "inventory":1,
            "price":1,
            "size":"default",
            "url": `/products/${product?.handle}?variant=${product?.variant_id}`
        };
        
    },
    updatePage : (product) => {
        
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/products/${product.handle}?variant=${product.variant_id}`;
        
    },
    
    /*addToCart : async (form)=> {
        //const form = document.querySelector("body.customized_product #add-to-cart-bar-product-form")
        const quantity = form.querySelector("input[name='quantity']").value
        const productId = form.querySelector("input[name='product-id']").value
        const variantId = form.querySelector("input[name='id']").value
        await window.theme.addToCart([{
            ['id']: variantId,
            ['quantity']: quantity,
            ['properties']: neatolabsCustomizationProperties[variantId],
            ['product-id']: productId
        }])
    },*/
    remove : async (variantId)=> {
        await fetch(`/cart/change?id=${variantId}&quantity=0`)
        const itemRow = document.querySelector(`.cart__item[data-variant='${variantId}']`);
        const input = itemRow.querySelector(`#quantity`);
        //const quantity = parseInt(input.value)
        input.value = 0
        itemRow.remove()
    },
    shopifyAddToCart: async (data) => {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                items: data
            })
        })
    },
    add : async (data)=> {
        
        //console.log("message", data)
        NeatolabsTakeyaCart.updateTheme(data.new_product)
        // Close the modal
        Neatolabs.control.modal.closeModal();
        
        const properties = data.properties;
        const productId = data.new_product.product_id
        const variantId = data.new_product.variant_id
        let quantity = data.quantity
        const isModified = data.is_modified
        
        if (isModified) {
            await NeatolabsTakeyaCart.remove(Neatolabs.data.product.variant_id)
            await NeatolabsTakeyaCart.shopifyAddToCart([{
                ['id']: variantId,
                ['quantity']: quantity,
                ['properties']: properties,
                ['product-id']: productId
            }])
            NeatolabsTakeyaCart.updatePage(data.new_product);
        } else {
            await window.theme.addToCart([{
                ['id']: variantId,
                ['quantity']: quantity,
                ['properties']: properties,
                ['product-id']: productId
            }]);
        }
        
        
        
        /*if (isModified) {
            NeatolabsTakeyaCart.updatePage(data.new_product);
        }*/
        
        
        
    },
}